import GetMediaDownloadToken from "../UseCase/GetMediaDownloadToken";
import {BackendURL} from "../../App/Constants/AppData";

const getMediaDownloadToken: GetMediaDownloadToken = new GetMediaDownloadToken(
    BackendURL ?? ''
);

export default function getGetMediaDownloadToken(): GetMediaDownloadToken {
    return getMediaDownloadToken;
}